import {styled} from "@mui/material/styles"
import CardMedia from "@mui/material/CardMedia"
import Typography from "@mui/material/Typography"
import {breakpoints} from "@next/themes"
import PsImageContainer from "../imageContainer"

interface TileCardMediaProps {
    component: string
    href: string
    $isPositionAbsolute?: boolean
    tabIndex: number
}

export const SwiperMobileContainer = styled(PsImageContainer)`
    .swiper-container {
        .swiper-slide {
            /* CSS specific to iOS devices */
            @supports (-webkit-touch-callout: none) {
                /* fixes ios rtl images flashing https://github.com/nolimits4web/swiper/issues/3527 */
                -webkit-transform: translate3d(0, 0, 0);
            }
        }
    }
`

export const TileCardMedia = styled(CardMedia, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<TileCardMediaProps>`
    height: auto;
    width: 100%;
    // Color value to be part of theme object - PBI23328
    background: #d1d1d1;
    text-decoration: none;
    padding: 0rem;
    top: 0rem;
    // stop the focus ring overflowing the product summary's border and getting cut off
    outline-offset: -0.125rem;

    &.sofa-background {
        background: white;
    }
`
export const TileImage = styled("img")`
    width: 100%;
    height: auto;
    display: block;
`

export const ThumbsComponent = styled("div")`
    display: flex;
`

export const NewInLabel = styled(Typography)`
    font-size: ${({theme}) => theme.colours.components.chipLabel2.fontSize};
    font-weight: ${({theme}) => theme.colours.components.chipLabel2.fontWeight};
    font-family: ${({theme}) => `${theme.colours.components.chipLabel2.fontFamily}, ${theme.colours.font.default}`};
    text-transform: ${({theme}) => theme.colours.components.chipLabel2.textTransform};
    text-decoration: ${({theme}) => theme.colours.components.chipLabel2.textTransform};
    letter-spacing: ${({theme}) => theme.colours.components.chipLabel2.letterSpacing};
    background-color: ${({theme}) => theme.colours.components.chips.filled.newin.enabled.backgroundColor};
    color: ${({theme}) => theme.colours.components.chips.filled.newin.enabled.color};
    left: 0;
    padding: 0.125rem 0.375rem;
    position: absolute;
    top: 0;
    white-space: nowrap;
    margin: 0rem;
`

export const EmptyDivider = styled("div")`
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        margin-bottom: 1.125rem;
    }
`
export const Embla = styled("section")({
    margin: "auto",
})

export const EmblaViewport = styled("div")({
    listStyle: "none",
    marginLeft: "auto",
    marginRight: "auto",
    padding: 0,
    position: "relative",
    zIndex: 1,
    overflow: "hidden",
})

export const EmblaContainer = styled("div")(() => ({
    boxSizing: "initial",
    display: "flex",
    position: "relative",
    width: "100%",
    zIndex: 1,
    backfaceVisibility: "hidden",
    transitionDuration: "0ms",
}))

export const EmblaSlide = styled("div")<{$slidesPerView?: number; $isVisible?: boolean}>(
    ({$slidesPerView = 1, $isVisible}) => `
    position: relative;
    visibility: ${$isVisible ? "visible" : "hidden"};
    min-width: 100%;
    flex: 0 0 100%;
    
    &.mobile {
        visibility: visible;
        min-width: 0;
        flex: 0 0 calc(100% / ${$slidesPerView});

        &.has-margin {
            margin-inline-end: 10px;
        }
    }
`,
)
